const gitHubConfig = {
    'User Agent' : 'd22054f8fc79e0e837dfa521eb3e19d2ed608ba2'
}

module.exports = gitHubConfig;


// WEBPACK FOOTER //
// ./src/config/git-hub-config.js